import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Object: { input: any; output: any; }
};

export type CreateReferralRequestInput = {
  orgCode: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
  respondents: Array<ReferralRequestRespondentInput>;
  serviceCode: Scalars['String']['input'];
  status: ReferralRequestStatus;
};

export type CreateReferralRequestResult = {
  __typename?: 'CreateReferralRequestResult';
  id: Scalars['ID']['output'];
  surveyResponseId?: Maybe<Scalars['ID']['output']>;
};

export type DeleteReferralRequestSurveyAttachmentInput = {
  attachmentId: Scalars['ID']['input'];
};

export type DraftReferralRequest = {
  __typename?: 'DraftReferralRequest';
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  organisationCode: Scalars['String']['output'];
  organisationName: Scalars['String']['output'];
  piSystem?: Maybe<Scalars['String']['output']>;
  piSystemId?: Maybe<Scalars['String']['output']>;
  readinessChecks: ReadinessChecks;
  respondents: Array<DraftReferralRequestRespondent>;
  serviceCode: Scalars['String']['output'];
  serviceDescription: Scalars['String']['output'];
  status: ReferralRequestStatus;
  surveyResponse?: Maybe<ReferralRequestSurveyResponse>;
};

export type DraftReferralRequestRespondent = {
  __typename?: 'DraftReferralRequestRespondent';
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  respondentType: RespondentType;
};

export type GetReferralRequestSurveyAttachmentDownloadUrlInput = {
  attachmentId: Scalars['ID']['input'];
};

export type GetSubmittedReferralsInput = {
  pagedQuery?: InputMaybe<PagedQuery>;
};

export type GetSubmittedReferralsResponse = {
  __typename?: 'GetSubmittedReferralsResponse';
  sessions: Array<ReferralSession>;
  totalCount: Scalars['Int']['output'];
};

export type Invite = {
  __typename?: 'Invite';
  createdAt: Scalars['Date']['output'];
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isRedeemed: Scalars['Boolean']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  publicId: Scalars['String']['output'];
  respondentType: RespondentType;
  serviceUserLink: Scalars['String']['output'];
  status: InviteStatus;
};

export enum InviteStatus {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Expired = 'expired',
  Pending = 'pending'
}

export type Mutation = {
  __typename?: 'Mutation';
  cancelReferralRequest: Scalars['Boolean']['output'];
  createReferralRequest: CreateReferralRequestResult;
  deleteReferralRequestSurveyAttachment: Scalars['Boolean']['output'];
  submitReferralRequest: Scalars['Boolean']['output'];
  updateReferralRequest: UpdateReferralRequestResult;
  updateReferralRequestSurvey: ReferralRequestSurveyDetail;
};


export type MutationCancelReferralRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateReferralRequestArgs = {
  input: CreateReferralRequestInput;
};


export type MutationDeleteReferralRequestSurveyAttachmentArgs = {
  input: DeleteReferralRequestSurveyAttachmentInput;
};


export type MutationSubmitReferralRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateReferralRequestArgs = {
  input: UpdateReferralRequestInput;
};


export type MutationUpdateReferralRequestSurveyArgs = {
  input: UpdateReferralRequestSurveyInput;
};

export type OrganisationSummary = {
  __typename?: 'OrganisationSummary';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PagedQuery = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type Patient = {
  __typename?: 'Patient';
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  piSystemId: PatientIdentifier;
};

export type PatientIdentifier = {
  __typename?: 'PatientIdentifier';
  id: Scalars['String']['output'];
  system: Scalars['String']['output'];
};

export type ProcessingReferralRequest = {
  __typename?: 'ProcessingReferralRequest';
  id: Scalars['ID']['output'];
  organisationName: Scalars['String']['output'];
  patientFamilyName: Scalars['String']['output'];
  patientGivenName: Scalars['String']['output'];
  piSystemId: Scalars['String']['output'];
  serviceDescription: Scalars['String']['output'];
  submittedAt: Scalars['Date']['output'];
};

export type ProfessionalReferralOrganisation = {
  __typename?: 'ProfessionalReferralOrganisation';
  cmsContentId?: Maybe<Scalars['String']['output']>;
};

export type ProfessionalReferralService = {
  __typename?: 'ProfessionalReferralService';
  organisation: OrganisationSummary;
  service: Service;
};

export type Query = {
  __typename?: 'Query';
  getDraftReferralRequests: Array<DraftReferralRequest>;
  getOrganisationReferrerEmailDomainWhitelist: Array<Scalars['String']['output']>;
  getProcessingReferralRequests: Array<ProcessingReferralRequest>;
  getProfessionalReferralServices: Array<ProfessionalReferralService>;
  getReferralRequest?: Maybe<DraftReferralRequest>;
  getReferralRequestService?: Maybe<ReferralRequestService>;
  getReferralRequestSurvey?: Maybe<ReferralRequestSurveyDetail>;
  getReferralRequestSurveyAttachmentDownloadUrl: ReferralRequestSurveyAttachmentDownloadUrl;
  getReferralRequestSurveyResponseAttachments: Array<ReferralRequestSurveyResponseAttachment>;
  getServiceUser?: Maybe<ServiceUserDetail>;
  getSubmittedReferrals: GetSubmittedReferralsResponse;
  validateOrganisationCode?: Maybe<ProfessionalReferralOrganisation>;
};


export type QueryGetOrganisationReferrerEmailDomainWhitelistArgs = {
  orgCode: Scalars['String']['input'];
};


export type QueryGetReferralRequestArgs = {
  id: Scalars['String']['input'];
  status: ReferralRequestStatus;
};


export type QueryGetReferralRequestServiceArgs = {
  orgCode: Scalars['String']['input'];
  serviceCode: Scalars['String']['input'];
};


export type QueryGetReferralRequestSurveyArgs = {
  referralRequestId: Scalars['String']['input'];
};


export type QueryGetReferralRequestSurveyAttachmentDownloadUrlArgs = {
  input: GetReferralRequestSurveyAttachmentDownloadUrlInput;
};


export type QueryGetReferralRequestSurveyResponseAttachmentsArgs = {
  referralRequestSurveyResponseId: Scalars['ID']['input'];
};


export type QueryGetSubmittedReferralsArgs = {
  input: GetSubmittedReferralsInput;
};


export type QueryValidateOrganisationCodeArgs = {
  orgCode: Scalars['String']['input'];
};

export enum ReadinessCheckErrorKey {
  ContactIncomplete = 'contactIncomplete',
  MissingPatientId = 'missingPatientId',
  NoPhoneNumber = 'noPhoneNumber',
  PatientIncomplete = 'patientIncomplete',
  SurveyIncomplete = 'surveyIncomplete'
}

export type ReadinessChecks = {
  __typename?: 'ReadinessChecks';
  errors: Array<ReadinessCheckErrorKey>;
  isReady: Scalars['Boolean']['output'];
};

export type Referral = {
  __typename?: 'Referral';
  organisation: OrganisationSummary;
  patient: Patient;
  service: Service;
};

export type ReferralRequestRespondentInput = {
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  respondentType: RespondentType;
};

export type ReferralRequestService = {
  __typename?: 'ReferralRequestService';
  description: Scalars['String']['output'];
  referrerSurvey?: Maybe<ReferrerSurvey>;
  respondentTypes: Array<RespondentType>;
};

export enum ReferralRequestStatus {
  Draft = 'draft',
  Submitted = 'submitted'
}

export type ReferralRequestSurveyAttachmentDownloadUrl = {
  __typename?: 'ReferralRequestSurveyAttachmentDownloadUrl';
  fileName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ReferralRequestSurveyDetail = {
  __typename?: 'ReferralRequestSurveyDetail';
  answers: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['Date']['output']>;
  definition: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ReferralRequestSurveyResponse = {
  __typename?: 'ReferralRequestSurveyResponse';
  answers: Scalars['JSON']['output'];
  completed: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
};

export type ReferralRequestSurveyResponseAttachment = {
  __typename?: 'ReferralRequestSurveyResponseAttachment';
  contentType: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  questionName: Scalars['String']['output'];
  referralRequestSurveyResponseId: Scalars['ID']['output'];
  sizeBytes: Scalars['Int']['output'];
};

export type ReferralSession = {
  __typename?: 'ReferralSession';
  createdAt: Scalars['Date']['output'];
  expiresAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  invites: Array<Invite>;
  referral: Referral;
  referralRequestId: Scalars['ID']['output'];
  status: ReferralSessionStatus;
};

export enum ReferralSessionStatus {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Expired = 'expired',
  Pending = 'pending'
}

export type ReferrerSurvey = {
  __typename?: 'ReferrerSurvey';
  definition: Scalars['String']['output'];
};

export enum RespondentType {
  Carer = 'carer',
  Informant1 = 'informant1',
  Patient = 'patient'
}

export type Service = {
  __typename?: 'Service';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  referrerDescription?: Maybe<Scalars['String']['output']>;
};

export type ServiceUserDetail = {
  __typename?: 'ServiceUserDetail';
  email?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type UpdateReferralRequestInput = {
  id: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
  respondents: Array<ReferralRequestRespondentInput>;
  status: ReferralRequestStatus;
};

export type UpdateReferralRequestResult = {
  __typename?: 'UpdateReferralRequestResult';
  surveyResponseId?: Maybe<Scalars['ID']['output']>;
};

export type UpdateReferralRequestSurveyInput = {
  answers: Scalars['String']['input'];
  complete?: InputMaybe<Scalars['Boolean']['input']>;
  expectedUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
};

export type GetOrganisationReferrerEmailDomainWhitelistQueryVariables = Exact<{
  orgCode: Scalars['String']['input'];
}>;


export type GetOrganisationReferrerEmailDomainWhitelistQuery = { __typename?: 'Query', getOrganisationReferrerEmailDomainWhitelist: Array<string> };


export const GetOrganisationReferrerEmailDomainWhitelistDocument = gql`
    query GetOrganisationReferrerEmailDomainWhitelist($orgCode: String!) {
  getOrganisationReferrerEmailDomainWhitelist(orgCode: $orgCode)
}
    `;

export function useGetOrganisationReferrerEmailDomainWhitelistQuery(options: Omit<Urql.UseQueryArgs<GetOrganisationReferrerEmailDomainWhitelistQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrganisationReferrerEmailDomainWhitelistQuery, GetOrganisationReferrerEmailDomainWhitelistQueryVariables>({ query: GetOrganisationReferrerEmailDomainWhitelistDocument, ...options });
};